/** Keys must match team names in nest-brc/scripts/world-cup-2026-matches.sql */
export const WORLD_CUP_2026_LEAGUE = 'WorldCup2026'

export const WORLD_CUP_2026_TEAM_FLAGS: Record<string, string> = {
  Algeria: '🇩🇿',
  Argentina: '🇦🇷',
  Australia: '🇦🇺',
  Austria: '🇦🇹',
  Belgium: '🇧🇪',
  'Bosnia and Herzegovina': '🇧🇦',
  Brazil: '🇧🇷',
  Canada: '🇨🇦',
  'Cape Verde': '🇨🇻',
  Colombia: '🇨🇴',
  Croatia: '🇭🇷',
  Curaçao: '🇨🇼',
  Czechia: '🇨🇿',
  'DR Congo': '🇨🇩',
  Ecuador: '🇪🇨',
  Egypt: '🇪🇬',
  England: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  France: '🇫🇷',
  Germany: '🇩🇪',
  Ghana: '🇬🇭',
  Haiti: '🇭🇹',
  Iran: '🇮🇷',
  Iraq: '🇮🇶',
  'Ivory Coast': '🇨🇮',
  Japan: '🇯🇵',
  Jordan: '🇯🇴',
  Mexico: '🇲🇽',
  Morocco: '🇲🇦',
  Netherlands: '🇳🇱',
  'New Zealand': '🇳🇿',
  Norway: '🇳🇴',
  Panama: '🇵🇦',
  Paraguay: '🇵🇾',
  Portugal: '🇵🇹',
  Qatar: '🇶🇦',
  'Saudi Arabia': '🇸🇦',
  Scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  Senegal: '🇸🇳',
  'South Africa': '🇿🇦',
  'South Korea': '🇰🇷',
  Spain: '🇪🇸',
  Sweden: '🇸🇪',
  Switzerland: '🇨🇭',
  Tunisia: '🇹🇳',
  Türkiye: '🇹🇷',
  USA: '🇺🇸',
  Uruguay: '🇺🇾',
  Uzbekistan: '🇺🇿',
}

const WORLD_CUP_2026_TEAM_FLAGS_BY_NORMALIZED: Record<string, string> = Object.fromEntries(
  Object.entries(WORLD_CUP_2026_TEAM_FLAGS).map(([name, flag]) => [normalizeTeamKey(name), flag])
)

const WORLD_CUP_2026_FLAG_ALIASES: Record<string, string> = {
  bosniaherzegovina: '🇧🇦',
  bosniaandherzegovina: '🇧🇦',
  southafrica: '🇿🇦',
  southkorea: '🇰🇷',
  ivrycoast: '🇨🇮',
  ivorycoast: '🇨🇮',
  drcongo: '🇨🇩',
  turkiye: '🇹🇷',
  turkey: '🇹🇷',
  curacao: '🇨🇼',
}

function normalizeTeamKey(teamName: string): string {
  return teamName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-zA-Z0-9]+/g, '')
    .toLowerCase()
    .trim()
}

export function getWorldCup2026TeamFlag(teamName: string): string | null {
  if (!teamName) return null
  const direct = WORLD_CUP_2026_TEAM_FLAGS[teamName]
  if (direct) return direct

  const normalized = normalizeTeamKey(teamName)
  return (
    WORLD_CUP_2026_TEAM_FLAGS_BY_NORMALIZED[normalized] ??
    WORLD_CUP_2026_FLAG_ALIASES[normalized] ??
    null
  )
}

export function isWorldCup2026League(league: string | null | undefined): boolean {
  return league === WORLD_CUP_2026_LEAGUE
}

export function normalizeRoomLeagues(leagues: string[] | string | null | undefined): string[] {
  if (!leagues) return []
  if (Array.isArray(leagues)) return leagues.filter(Boolean)
  return String(leagues).split(',').map(s => s.trim()).filter(Boolean)
}

/** Use match.league when present; otherwise infer from room leagues (World Cup rooms). */
export function resolveMatchLeague(
  matchLeague: string | null | undefined,
  roomLeagues?: string[] | string | null,
): string | null | undefined {
  if (matchLeague) return matchLeague
  const leagues = normalizeRoomLeagues(roomLeagues)
  if (leagues.length === 1) return leagues[0]
  if (leagues.includes(WORLD_CUP_2026_LEAGUE)) return WORLD_CUP_2026_LEAGUE
  return matchLeague ?? null
}
